
import { map, catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core";



import { Observer } from "rxjs";
import { Observable } from "rxjs/internal/Observable";

import * as JWT from 'jwt-decode';

import { resolve } from 'url';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { API_ADDRESS, ADMIN_EMAILS } from '../../core/_shared/constants';
import { LottolocaDebugger } from '../../core/_shared/utils/lottoloca-debugger';

const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    })
  };

@Injectable()
export class UserService {
    
    
    login(loginData: any )
    {


            return this.http.post(API_ADDRESS + '/ApplicationUser/Login', loginData,httpOptions);
    
    }


    setCurrentUserEmail(email: string) {

        //this.cookieService.set("simulatingUserEmail", email)
 

    }

    // getCurrentUserEmail(): any {

    //     return getCurrentUserEmail(false);
    // }

    getCurrentUserEmailX(withoutEmulated: boolean = false): any {

        let idToken: string;

        if (this.idToken != null) {
            idToken = this.idToken;
        }
        else {
            idToken = this.idToken = localStorage.getItem('idToken');
        }

        let email = JWT(idToken)['Email'];

        LottolocaDebugger.log(22,"Email: "+ email);

        LottolocaDebugger.log(22,JWT(idToken));

        if (ADMIN_EMAILS.some(x => x == email) && !withoutEmulated) {
            let simulatingUserEmail = "";//  this.cookieService.get("simulatingUserEmail");

            if (simulatingUserEmail != null && simulatingUserEmail != "") {
                return simulatingUserEmail;
            }
        }

        LottolocaDebugger.log(22,"Email: "+ email);

        return email;
    }

isSimulateUserEmail(): any 
{
    let idToken: string;

    if (this.idToken != null) {
        idToken = this.idToken;
    }
    else {
        idToken = this.idToken = localStorage.getItem('idToken');
    }

    let email = JWT(idToken)['Email'];

    LottolocaDebugger.log(22,"Email: "+ email);

    LottolocaDebugger.log(22,JWT(idToken));

    if (ADMIN_EMAILS.some(x => x == email)) {
        let simulatingUserEmail = "";// this.cookieService.get("simulatingUserEmail");

        if (simulatingUserEmail != null && simulatingUserEmail != "") {
            return true;
        }
    }

   return false;
}

    getCurrentUserId(withoutEmulated: boolean = false): string {

        let idToken: string;

        if (this.idToken != null) {
            idToken = this.idToken;
        }
        else {
            idToken = this.idToken = localStorage.getItem('idToken');
        }

      

        let userId = JWT(idToken)['UserID'];

        // if (ADMIN_EMAILS.some(x => x == email) && !withoutEmulated) {
        //     let simulatingUserEmail = this.cookieService.get("simulatingUserEmail");

        //     if (simulatingUserEmail != null && simulatingUserEmail != "") {
        //         return simulatingUserEmail;
        //     }
        // }

        return userId;
    }



    idToken: any;
    public authMode: number = 0;

    constructor(private http: HttpClient) {
    }

//, private cookieService: CookieService
    verify()
    {
      
        return this.http.get(API_ADDRESS +'/UserProfile/IsLogged', httpOptions ).pipe(map((response: Response) => response.json()));
    }

    verifyold2(url: string) {

        let result: boolean = false;

        if (this.authMode == 0) {
            if (this.idToken != null) {
                result = true;
            }
            else {
                if (localStorage.getItem('idToken') != null) {
                    this.idToken = localStorage.getItem('idToken');
                    result = true;
                }
            }

         
    
             this.http.get(API_ADDRESS + `/UserProfile/IsLogged`,  httpOptions)
                .pipe(
                    map(result => {
    
              
    
                    }
                    
    
                    ),catchError(errorx=>
                        {
           
                            return errorx;
                        })).toPromise().then(
data=>
{
    console.log("Verificando permissão");
    console.log(data) ;
}

                    );



            if (result && url.indexOf("/admins") == 0) {


                if (this.getCurrentUserEmailX(true) != "andre@spolti.com.br") {
                    result = false;

                }
            }

            return result;


        }

    }

    // verifyOld() {

    //     return this.http.get('/api/verify', this.jwt()).pipe(map((response: Response) => response.json()));
    // }

    forgotPassword(email: string): Promise<void> {

        return null;
        // var auth = firebase.auth();
        // var emailAddress = email;

        // return auth.sendPasswordResetEmail(emailAddress).then(function () {
        //     // Email sent.
        // });

        // .catch(function(error) {
        //   // An error happened.
        // });

        // return firebase.auth().for

        // return this.http.post('/api/forgot-password', JSON.stringify({ email }), this.jwt()).pipe(map((response: Response) => response.json()));
    }

    // getAll() {
    //     return this.http.get('/api/users', this.jwt()).pipe(map((response: Response) => response.json()));
    // }

    // getById(id: number) {
    //     return this.http.get('/api/users/' + id, this.jwt()).pipe(map((response: Response) => response.json()));
    // }

    // create(user: User): Promise<any> {

   
    //     let promise =  new Promise<any>((resolve,reject)=>
    //     {

    //         let requestOptions = new RequestOptions({ method: RequestMethod.Post });
    //         requestOptions.headers = new Headers({ 'Content-Type': 'application/json' })
    
    //       console.log(user);
    //             return this.http.post(API_ADDRESS + '/ApplicationUser/Register', 
    //             { FullName:user.fullname,Email:user.email, UserName: user.email, Password: user.password },requestOptions)
    //            .toPromise()
    //            .then(data=>
    //             {
    //                 let result = data.json();

    //                 console.log(result);
    //                 if(result.succeeded == true)
    //                 {
    //                     resolve(result);
    //                 }
    //                 else{

    //                     let error = "Ocorreu um erro para cadastrar o usuário : "
    //                     if(result.errors[0].code==  "DuplicateUserName")
    //                     {
    //                         error  = "Esse usuário já está cadastrado !!!"
    //                     }
    //                     else{
    //                         error += result.errors[0];
    //                     }
    //                     reject(error);
                        
    //                 }
    //             })
    
    //     });
    
    //     return promise;

    // }

    // update(user: User) {
    //     return this.http.put('/api/users/' + user.id, user, this.jwt()).pipe(map((response: Response) => response.json()));
    // }

    // delete(id: number) {
    //     return this.http.delete('/api/users/' + id, this.jwt()).pipe(map((response: Response) => response.json()));
    // }

    // private helper methods

    // private jwt() {


    //     // create authorization header with jwt token
    //     let currentUser = JSON.parse(localStorage.getItem('currentUser'));


    //     let idToken = localStorage.getItem('idToken');


    //     // if (currentUser && currentUser.token) {

    //     if (currentUser && idToken) {
    //         let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
    //         return new RequestOptions({ headers: headers });
    //     }
    // }
}